import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { colors } from '@styleseat/brand';
import withStore from '../../../withStore';
import NotificationBanner from '../NotificationBanner';
import FLAME_ICON from '../../../../../images/flame.svg';
import { CALENDAR_ROUTE } from '../../../../route-names';

export const SearchBoostEligibilityNotification = ({
  notification,
  linkTo,
  showPromoteButton,
}) => {
  const { provider_id: providerId } = notification;
  const route = showPromoteButton ? 'responsive.provider.promote' : CALENDAR_ROUTE;
  const routeParams = {
    providerId,
    source: 'notification',
  };

  const buttonProps = {
    appearance: 'text-light',
    size: 'small',
    text: showPromoteButton ? 'Share Profile' : 'Add Appointment',
    onClick: () => {
      linkTo(route, routeParams);
    },
    clickTracking: {
      name: `pro_notification_search_boost_eligibility_${showPromoteButton ? 'promote_profile' : 'add_appointment'}_clicked`,
      params: {
        notification_type: 'search_boost_eligibility',
        provider_id: providerId,
      },
    },
  };

  return (
    <NotificationBanner
      notification={notification}
      icon={FLAME_ICON}
      highlightedText="Get a Search Boost!"
      text="Book 6 appointments in the next 14 days and we&apos;ll boost your profile"
      highlightBorderColor={colors.petal}
      highlightedSubText="Search Boost"
      subText="pushes your business to the top of client searches in your area."
      buttonProps={buttonProps}
    />
  );
};

SearchBoostEligibilityNotification.propTypes = {
  notification: PropTypes.object.isRequired,
  linkTo: PropTypes.func,
  showPromoteButton: PropTypes.bool,
};

SearchBoostEligibilityNotification.defaultProps = {
  linkTo: () => { },
  showPromoteButton: true,
};

const mapDispatchToProps = dispatch => ({
  linkTo: (route, params, notify = true) => {
    dispatch.route.go({
      route,
      params,
      notify,
    });
  },
});

export default withStore(connect(null, mapDispatchToProps)(SearchBoostEligibilityNotification));
